import { User } from 'features/user'
import { Can } from '../Can'
import { onAbTestsCreateUpdateDelete } from './features/abTests'
import { onAdUnitMediaTypesCUD, onAdUnitYbAdUnitEnabledCreateUpdate } from './features/adUnit'
import {
  onDomainAdvancedSettingsUpdate,
  onDomainBulkManagementCreate,
  onDomainCreateUpdateDelete,
  onDomainCustomCodeUpdate,
  onDomainOverridenByYieldbirdRead,
  onDomainOverridenByYieldbirdUpdate,
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionUpdate,
  onDomainUnfilledRecoveryBaseAdUnitPathUpdate,
} from './features/domain'
import { onGlobalSetupAmazonUpdate } from './features/globalSetup/amazon'
import {
  onGlobalSetupPriceGeniusUpdate,
  onGlobalSetupWorkspaceUserACUD,
} from './features/globalSetup/common'
import {
  onGlobalSetupDefaultsPrebidStackUpdate,
  onGlobalSetupDefaultsPrebidVariableNameUpdate,
  onGlobalSetupDefaultsRichPlacementsUpdate,
} from './features/globalSetup/defaults'
import {
  onGlobalSetupGoogleAdManagerConnectionUpdate,
  onGlobalSetupGoogleAdManagerSetupRetargetingDeliveryItemsReadUpdate,
} from './features/globalSetup/googleAccountManagerConnection'
import {
  onGlobalSetupBiddersBidParamsCommonUpdate,
  onGlobalSetupBiddersBidParamsOwnUpdate,
  onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate,
  onGlobalSetupBiddersBidParamsYieldbirdUpdate,
  onGlobalSetupBiddersCUD,
  onGlobalSetupBiddersOwnUpdate,
  onGlobalSetupBiddersThirdPartyUpdate,
  onGlobalSetupBiddersYieldbirdCpmConsentStatusUpdate,
  onGlobalSetupBiddersYieldbirdUpdate,
  onGlobalSetupPrebidBiddersAddaccess,
  onGlobalSetupPrebidModuleCUD,
  onGlobalSetupPrebidModulesGeneralParamsOwnUpdate,
  onGlobalSetupPrebidModulesGeneralParamsYieldbirdUpdate,
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnUpdate,
  onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead,
  onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdUpdate,
  onGlobalSetupPrebidModuleStatusUpdate,
  onGlobalSetupProtectionACUD,
} from './features/globalSetup/prebid'
import {
  onGlobalSetupSupplyChainAddAccess,
  onGlobalSetupSupplyChainCUD,
} from './features/globalSetup/supplyChain'
import { onViewportCUD } from './features/globalSetup/viewport'
import { onPageAddAccess, onPageCreateUpdateDelete } from './features/page'
import { onPerformanceDataSamplingReadUpdate } from './features/performance'
import { onUserPageEmployeeACUD, onUserPagePublisherACUD } from './features/user'
import { onWorkspaceDelete, onWorkspaceSelectUse } from './features/workspace'

export const userByRole = (user: User, can: Can) => {
  switch (user.role) {
    case 'admin': {
      onAbTestsCreateUpdateDelete(can)
      onAdUnitMediaTypesCUD(can)
      onAdUnitYbAdUnitEnabledCreateUpdate(can)
      onDomainAdvancedSettingsUpdate(can)
      onDomainBulkManagementCreate(can)
      onDomainCreateUpdateDelete(can)
      onDomainCustomCodeUpdate(can)
      onDomainOverridenByYieldbirdRead(can)
      onDomainOverridenByYieldbirdUpdate(can)
      onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionUpdate(can)
      onDomainUnfilledRecoveryBaseAdUnitPathUpdate(can)
      onGlobalSetupAmazonUpdate(can)
      onGlobalSetupBiddersBidParamsCommonUpdate(can)
      onGlobalSetupBiddersBidParamsOwnUpdate(can)
      onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate(can)
      onGlobalSetupBiddersBidParamsYieldbirdUpdate(can)
      onGlobalSetupBiddersCUD(can)
      onGlobalSetupBiddersOwnUpdate(can)
      onGlobalSetupBiddersThirdPartyUpdate(can)
      onGlobalSetupBiddersYieldbirdCpmConsentStatusUpdate(can)
      onGlobalSetupBiddersYieldbirdUpdate(can)
      onGlobalSetupDefaultsPrebidStackUpdate(can)
      onGlobalSetupDefaultsPrebidVariableNameUpdate(can)
      onGlobalSetupDefaultsRichPlacementsUpdate(can)
      onGlobalSetupGoogleAdManagerConnectionUpdate(can)
      onGlobalSetupGoogleAdManagerSetupRetargetingDeliveryItemsReadUpdate(can)
      onGlobalSetupPrebidBiddersAddaccess(can)
      onGlobalSetupPrebidModuleCUD(can)
      onGlobalSetupPrebidModulesGeneralParamsOwnUpdate(can)
      onGlobalSetupPrebidModulesGeneralParamsYieldbirdUpdate(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsOwnUpdate(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdUpdate(can)
      onGlobalSetupPrebidModuleStatusUpdate(can)
      onGlobalSetupPriceGeniusUpdate(can)
      onGlobalSetupProtectionACUD(can)
      onGlobalSetupSupplyChainAddAccess(can)
      onGlobalSetupSupplyChainCUD(can)
      onGlobalSetupWorkspaceUserACUD(can)
      onPageAddAccess(can)
      onPageCreateUpdateDelete(can)
      onPerformanceDataSamplingReadUpdate(can)
      onUserPageEmployeeACUD(can)
      onUserPagePublisherACUD(can)
      onViewportCUD(can)
      onWorkspaceDelete(can)
      break
    }

    case 'adops': {
      onAbTestsCreateUpdateDelete(can)
      onAdUnitMediaTypesCUD(can)
      onAdUnitYbAdUnitEnabledCreateUpdate(can)
      onDomainAdvancedSettingsUpdate(can)
      onDomainBulkManagementCreate(can)
      onDomainCreateUpdateDelete(can)
      onDomainCustomCodeUpdate(can)
      onDomainOverridenByYieldbirdRead(can)
      onDomainOverridenByYieldbirdUpdate(can)
      onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionUpdate(can)
      onDomainUnfilledRecoveryBaseAdUnitPathUpdate(can)
      onGlobalSetupAmazonUpdate(can)
      onGlobalSetupBiddersBidParamsCommonUpdate(can)
      onGlobalSetupBiddersBidParamsOwnUpdate(can)
      onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate(can)
      onGlobalSetupBiddersBidParamsYieldbirdUpdate(can)
      onGlobalSetupBiddersCUD(can)
      onGlobalSetupBiddersOwnUpdate(can)
      onGlobalSetupBiddersThirdPartyUpdate(can)
      onGlobalSetupBiddersYieldbirdCpmConsentStatusUpdate(can)
      onGlobalSetupBiddersYieldbirdUpdate(can)
      onGlobalSetupDefaultsPrebidStackUpdate(can)
      onGlobalSetupDefaultsPrebidVariableNameUpdate(can)
      onGlobalSetupDefaultsRichPlacementsUpdate(can)
      onGlobalSetupGoogleAdManagerConnectionUpdate(can)
      onGlobalSetupGoogleAdManagerSetupRetargetingDeliveryItemsReadUpdate(can)
      onGlobalSetupPrebidBiddersAddaccess(can)
      onGlobalSetupPrebidModuleCUD(can)
      onGlobalSetupPrebidModulesGeneralParamsOwnUpdate(can)
      onGlobalSetupPrebidModulesGeneralParamsYieldbirdUpdate(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsOwnUpdate(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdUpdate(can)
      onGlobalSetupPrebidModuleStatusUpdate(can)
      onGlobalSetupPriceGeniusUpdate(can)
      onGlobalSetupProtectionACUD(can)
      onGlobalSetupSupplyChainAddAccess(can)
      onGlobalSetupSupplyChainCUD(can)
      onGlobalSetupWorkspaceUserACUD(can)
      onPageAddAccess(can)
      onPageCreateUpdateDelete(can)
      onPerformanceDataSamplingReadUpdate(can)
      onUserPagePublisherACUD(can)
      onViewportCUD(can)
      break
    }

    case 'backOffice': {
      onDomainCreateUpdateDelete(can)
      onDomainOverridenByYieldbirdRead(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead(can)
      onPageCreateUpdateDelete(can)
      onViewportCUD(can)
      break
    }

    case 'customerPerformance': {
      onAbTestsCreateUpdateDelete(can)
      onAdUnitMediaTypesCUD(can)
      onAdUnitYbAdUnitEnabledCreateUpdate(can)
      onDomainAdvancedSettingsUpdate(can)
      onDomainBulkManagementCreate(can)
      onDomainCreateUpdateDelete(can)
      onDomainOverridenByYieldbirdRead(can)
      onDomainOverridenByYieldbirdUpdate(can)
      onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionUpdate(can)
      onDomainUnfilledRecoveryBaseAdUnitPathUpdate(can)
      onGlobalSetupAmazonUpdate(can)
      onGlobalSetupBiddersBidParamsCommonUpdate(can)
      onGlobalSetupBiddersBidParamsOwnUpdate(can)
      onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate(can)
      onGlobalSetupBiddersBidParamsYieldbirdUpdate(can)
      onGlobalSetupBiddersCUD(can)
      onGlobalSetupBiddersOwnUpdate(can)
      onGlobalSetupBiddersThirdPartyUpdate(can)
      onGlobalSetupBiddersYieldbirdCpmConsentStatusUpdate(can)
      onGlobalSetupBiddersYieldbirdUpdate(can)
      onGlobalSetupDefaultsPrebidStackUpdate(can)
      onGlobalSetupDefaultsPrebidVariableNameUpdate(can)
      onGlobalSetupDefaultsRichPlacementsUpdate(can)
      onGlobalSetupGoogleAdManagerConnectionUpdate(can)
      onGlobalSetupGoogleAdManagerSetupRetargetingDeliveryItemsReadUpdate(can)
      onGlobalSetupPrebidBiddersAddaccess(can)
      onGlobalSetupPrebidModuleCUD(can)
      onGlobalSetupPrebidModulesGeneralParamsOwnUpdate(can)
      onGlobalSetupPrebidModulesGeneralParamsYieldbirdUpdate(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsOwnUpdate(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdUpdate(can)
      onGlobalSetupPrebidModuleStatusUpdate(can)
      onGlobalSetupPriceGeniusUpdate(can)
      onGlobalSetupProtectionACUD(can)
      onGlobalSetupSupplyChainAddAccess(can)
      onGlobalSetupSupplyChainCUD(can)
      onGlobalSetupWorkspaceUserACUD(can)
      onPageAddAccess(can)
      onPageCreateUpdateDelete(can)
      onPerformanceDataSamplingReadUpdate(can)
      onUserPagePublisherACUD(can)
      onViewportCUD(can)
      break
    }

    case 'customerSuccess': {
      onDomainCreateUpdateDelete(can)
      onDomainOverridenByYieldbirdRead(can)
      onGlobalSetupBiddersBidParamsOwnUpdate(can)
      onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate(can)
      onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead(can)
      onGlobalSetupWorkspaceUserACUD(can)
      onPageCreateUpdateDelete(can)
      onUserPagePublisherACUD(can)
      onViewportCUD(can)
      break
    }

    case 'publisher': {
      onWorkspaceSelectUse(can)
      break
    }
  }
}
